import axios from "axios";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

class GeneralWebService {
  //No use
  static async getSectionDetailsByCode(id, keyword) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/istudio/api/icms/v1/record/read/template?code=faq_by_category`);
    let resp = await axios.post(
      url,
      {
        "<keyword>": keyword,
        "<category>": id,
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getFAQCategories(keyword) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/istudio/api/icms/v1/record/read/template?code=faq_categories`);
    let resp = await axios.post(
      url,
      {
        "<keyword>": keyword,
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getTemplateDataByCode(code) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/advance/template?code=${code}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getPendingSubmission(code) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/template?code=${code}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getRecentActivities(code) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/template?code=${code}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  /* static async getQuickLinks() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/asset/general`);
    let resp = await axios.get(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  } */

  static async getQuickLinksForms() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/asset/form`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getQuickLinksProducts() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/asset/product`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async updateLanguage(productCode) {
    let corrId = ""; /* GeneralBloc.getCurrentSessionId(productCode) */
    let headers = BaseWebService.headers(productCode, corrId);
    let url=DOMPurify.sanitize(BaseWebService.baseUrl() + "/transaction/updateSelectedLanguage");
    let resp = await axios.get(
      url,
      { headers: headers }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static getMrttBusinessContextPath() {
    return "/mrtt/prubsn/api/v1";
  }
  //getAnnouncements
  static async getAnnouncements() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/announcement`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getCampaigns
  static async getCampaigns() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/campaign`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  
  static async getQuickLinks() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/asset/general`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getScreenConfig
  static async getScreenConfig() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/frontendConfig`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getMasterDataWithCode
  static async getMasterDataWithCode(param) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/master${param}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async deleteUploadDocs(payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BREACT_APP_BASE_URL_CMSASE_URL}/record/delete`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //saveUploadDocs
  static async saveUploadDocs(entity, payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/saveOrUpdate?entity=${entity}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getUploadDocsById
  static async getUploadDocsById(code, payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/template?code=${code}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getAllUploadDocs
  static async getAllUploadDocs(code, payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/template?code=${code}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getProductListDependOnPartner
  static async getProductListDependOnPartner(session) {
    let headers = BaseWebService.headers(
      session.productCode,
      session.partnerCode,
      session.trxId
    );
    let url=DOMPurify.sanitize(BaseWebService.baseUrl() + "/partner/products");
    let resp = await axios.get(url, {
      headers: headers,
    });
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getDateRangeFilter
  static async getDateRangeFilter(token, id) {
    let header = await BaseWebService.headers();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/list`);
    let resp = await axios.post(
      url,
      {
        id: !id ? "df-master-config-show-within" : id,
      },
      {
        headers: header,
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getDateRangeUpcomingFilter no use
  static async getDateRangeUpcomingFilter(token, id) {
    let header = await BaseWebService.headers();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/list`);
    let resp = await axios.post(
      url,
      {
        id: !id ? "df-master-config-show-within-upcoming" : id,
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getSearchBys no use
  static async getSearchBys(token, id) {
    let header = await BaseWebService.headers();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/list`);
    let resp = await axios.post(
      url,
      {
        id: id,
      },
      {
        headers: header,
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getModuleCount(
    module,
    token,
    entity,
    criParams,
    bypassRowsOfPage
  ) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/list`);
    let resp = await axios.post(
      url,
      {
        id: module,
        bypassRowsOfPage: bypassRowsOfPage || true,
        criParams: criParams,
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getBranchList(token, regions) {
    let header = await BaseWebService.headers();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/list`);
    let resp = await axios.post(
      url,
      {
        id: "df-branch-list",
        criParams: {
          regions: regions,
        },
      },
      {
        headers: header,
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
 
  //No use
  static async getDynamicFilter(token, endpoint, request) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/${endpoint}`);
    let resp = await axios.post(
      url,
      JSON.parse(request),
      {
        headers: header,
      }
    );
    return resp.data;
  }

  //No use
  static async getSearchCriteriaList(token, regions, id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/list`);
    let resp = await axios.post(
      url,
      {
        id: id,
        criParams: {
          regions: regions,
        },
      },
      {
        headers: header,
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getAgentList(token, regions, branches) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/agentList`);
    let resp = await axios.post(
      url,
      {
        regions: regions,
        branches: branches,
      },
      {
        headers: header,
      }
    );

    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async exportFileByModule(token, entity, payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/v1/export`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
        responseType: "blob",
      }
    );
    return resp;
  }

  // Get EUSA Status
  static async getEUSAStatus() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/eusa`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    return resp.data;
  }

  // Update EUSA Status
  static async updateEUSAStatus() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/eusa`);
    let resp = await axios.post(
      url,
      {
        accept: true,
      },
      {
        headers: header,
      }
    );
    return resp.data;
  }

  // View EUSA Document
  static async viewEUSA() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/asset/general`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    return resp.data;
  }

  // View Profile
  static async getProfile() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/user/user_profile`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    return resp.data;
  }

  static async checkOTPByPass(type) {
    let header = await BaseWebService.tmpHeaders(type);
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/general/bypassOTP`);
    let resp = await axios.get(
      url,
      { headers: header }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
}

export default GeneralWebService;
